export default __webpack_public_path__ + "static/media/Other.3f7a661e.svg";